import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useChat } from '../../context/ChatContext';

/**
 * Component to handle chat URL parameters and open floating chat
 * Should be rendered at the app level to catch /chat/:conversationId?token=xxx URLs
 */
const ChatUrlHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { openChat } = useChat();

  useEffect(() => {
    // Check if we're on a chat route
    if (location.pathname.startsWith('/chat/')) {
      // Extract conversationId from pathname (e.g., /chat/abc-123 -> abc-123)
      const pathParts = location.pathname.split('/');
      const conversationId = pathParts[2]; // /chat/[conversationId]
      
      // Extract token from query string
      const searchParams = new URLSearchParams(location.search);
      const token = searchParams.get('token');

      console.log('[ChatUrlHandler] Detected chat URL:', { 
        pathname: location.pathname,
        conversationId, 
        hasToken: !!token,
        search: location.search
      });

      if (conversationId && token) {
        // Open the floating chat
        console.log('[ChatUrlHandler] Opening chat with conversationId:', conversationId);
        openChat(conversationId, token);

        // Small delay to ensure chat opens before redirect
        setTimeout(() => {
          // Clear URL parameters and redirect to dashboard
          // This keeps the chat open but removes sensitive token from URL
          navigate('/dashboard', { replace: true });
        }, 100);
      } else {
        console.log('[ChatUrlHandler] Invalid chat link - missing conversationId or token', {
          conversationId,
          hasToken: !!token
        });
        // Invalid chat link, redirect to dashboard
        navigate('/dashboard', { replace: true });
      }
    }
  }, [location.pathname, location.search, navigate, openChat]);

  return null; // This component doesn't render anything
};

export default ChatUrlHandler;

